import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  Testdatenblatt,
  TestdatenblattCreateRequest,
  TestdatenblattUpdateRequest,
} from '../models/testdatenblatt.model';

@Injectable({ providedIn: 'root' })
export class TestdatenblattService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  private url(projectId: string, id?: string): string {
    const root = `${this.base}/${projectId}/testdatenblaetter`;
    return id ? `${root}/${id}` : root;
  }

  list(projectId: string): Observable<Testdatenblatt[]> {
    return this.http.get<Testdatenblatt[]>(this.url(projectId));
  }

  getById(projectId: string, id: string): Observable<Testdatenblatt> {
    return this.http.get<Testdatenblatt>(this.url(projectId, id));
  }

  create(projectId: string, request: TestdatenblattCreateRequest): Observable<Testdatenblatt> {
    return this.http.post<Testdatenblatt>(this.url(projectId), request);
  }

  update(projectId: string, id: string, request: TestdatenblattUpdateRequest): Observable<Testdatenblatt> {
    return this.http.put<Testdatenblatt>(this.url(projectId, id), request);
  }

  delete(projectId: string, id: string): Observable<void> {
    return this.http.delete<void>(this.url(projectId, id));
  }

  linkModule(projectId: string, id: string, moduleId: string): Observable<void> {
    return this.http.put<void>(this.moduleLinkUrl(projectId, id, moduleId), null);
  }

  unlinkModule(projectId: string, id: string, moduleId: string): Observable<void> {
    return this.http.delete<void>(this.moduleLinkUrl(projectId, id, moduleId));
  }

  private moduleLinkUrl(projectId: string, id: string, moduleId: string): string {
    return `${this.url(projectId, id)}/test-modules/${moduleId}`;
  }
}
